exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-box[data-v-2b844497] {\n  width: 95%;\n  max-height: 300px;\n  background-color: #fff;\n  box-shadow: 0.2px 0.2px .5px rgb(80, 78, 78, 0.447);\n  border-radius: 10px;\n  padding: 10px;\n  z-index: 1000 !important;\n  position: absolute;\n  top: 60px;\n  left: 0;\n  margin: 0 10px;\n  overflow: scroll;\n}\n.consultant-link[data-v-2b844497] {\n  cursor: pointer;\n}\n", ""]);

// exports
